/* eslint-disable react/display-name */
import { forwardRef } from "react";

import PropTypes from "prop-types";

const OrderStatusButton = forwardRef(({ status, className, onClick }, ref) => {
  return (
    <button
      ref={ref}
      className={`${className} mr-[0.75rem] min-w-[8.5rem] rounded-[0.5rem] py-[0.563rem] text-[1rem] lg:py-[0.781rem]`}
      onClick={() => onClick(status)}
    >
      {status.label}
    </button>
  );
});

OrderStatusButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  status: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    id: PropTypes.string,
  }),
};

export default OrderStatusButton;
